const zooNNmodel = {
  sizes: [24, 12, 7],
  layers: [
    {
      "0": {},
      "1": {},
      "2": {},
      "3": {},
      "4": {},
      "5": {},
      "6": {},
      "7": {},
      "8": {},
      "9": {},
      "10": {},
      "11": {},
      "12": {},
      "13": {},
      "14": {},
      "15": {},
      "16": {},
      "17": {},
      "18": {},
      "19": {},
      "20": {},
      "21": {},
      "22": {},
      "23": {},
    },
    {
      "0": {
        bias: 1.915802240371704,
        weights: {
          "0": 1.9529658555984497,
          "1": -14.64197826385498,
          "2": 36.167938232421875,
          "3": -38.499114990234375,
          "4": -12.723976135253906,
          "5": 5.301478385925293,
          "6": -8.676627159118652,
          "7": 71.61634063720703,
          "8": 56.882110595703125,
          "9": -115.76860046386719,
          "10": -33.269256591796875,
          "11": 131.41702270507812,
          "12": 86.67635345458984,
          "13": -0.19114471971988678,
          "14": -16.59112548828125,
          "15": -0.179923877120018,
          "16": -57.41156768798828,
          "17": -9.431222915649414,
          "18": 7.832256317138672,
          "19": -0.018411217257380486,
          "20": -8.883370399475098,
          "21": 90.55693054199219,
          "22": 10.684778213500977,
          "23": 26.232757568359375,
        },
      },
      "1": {
        bias: 7.501952648162842,
        weights: {
          "0": 74.00601196289062,
          "1": -29.187076568603516,
          "2": -138.7101287841797,
          "3": 166.57928466796875,
          "4": 15.683155059814453,
          "5": -11.149252891540527,
          "6": -6.075345039367676,
          "7": 67.49336242675781,
          "8": 38.496185302734375,
          "9": 53.24520492553711,
          "10": -28.870569229125977,
          "11": 43.937408447265625,
          "12": 43.55467987060547,
          "13": 0.029902102425694466,
          "14": 17.98794937133789,
          "15": 0.19399887323379517,
          "16": -23.285268783569336,
          "17": -0.6787868142127991,
          "18": -8.852667808532715,
          "19": -0.02894594334065914,
          "20": -20.291545867919922,
          "21": 17.7286376953125,
          "22": 8.164763450622559,
          "23": 17.924503326416016,
        },
      },
      "2": {
        bias: 37.21466064453125,
        weights: {
          "0": 39.67253494262695,
          "1": -19.821605682373047,
          "2": 69.35320281982422,
          "3": -1.2918035984039307,
          "4": 94.98712158203125,
          "5": -96.8648910522461,
          "6": -59.875667572021484,
          "7": -17.22047996520996,
          "8": -37.045310974121094,
          "9": 112.84561920166016,
          "10": -19.463106155395508,
          "11": -7.625577449798584,
          "12": -9.040168762207031,
          "13": 0.05018014460802078,
          "14": -21.213159561157227,
          "15": 0.16295814514160156,
          "16": -8.167229652404785,
          "17": -7.5214948654174805,
          "18": 117.73596954345703,
          "19": -0.15359750390052795,
          "20": -30.683271408081055,
          "21": -38.61552810668945,
          "22": 2.9825057983398438,
          "23": 3.0660858154296875,
        },
      },
      "3": {
        bias: 2.3305351734161377,
        weights: {
          "0": 41.11157989501953,
          "1": -21.327884674072266,
          "2": -92.5839614868164,
          "3": 103.45275115966797,
          "4": 7.097679138183594,
          "5": -9.668460845947266,
          "6": 2.294372081756592,
          "7": 40.21587371826172,
          "8": 18.89532470703125,
          "9": 46.09358596801758,
          "10": -15.203227043151855,
          "11": 13.953729629516602,
          "12": 13.273615837097168,
          "13": 0.19651691615581512,
          "14": 10.976367950439453,
          "15": -0.15204359591007233,
          "16": -5.464981555938721,
          "17": -0.40130913257598877,
          "18": -7.585319995880127,
          "19": 0.03761181980371475,
          "20": -7.873733997344971,
          "21": 8.957365989685059,
          "22": 1.1067167520523071,
          "23": 4.517535209655762,
        },
      },
      "4": {
        bias: 0.07503066956996918,
        weights: {
          "0": 8.043383598327637,
          "1": -30.857952117919922,
          "2": 7.628671169281006,
          "3": 24.2445011138916,
          "4": 5.758119106292725,
          "5": 46.33269500732422,
          "6": -34.31702423095703,
          "7": 138.57757568359375,
          "8": 108.21919250488281,
          "9": 75.8935775756836,
          "10": -16.95448875427246,
          "11": 34.020729064941406,
          "12": -4.28739595413208,
          "13": 0.08812303841114044,
          "14": -9.967974662780762,
          "15": -0.19779939949512482,
          "16": 85.55054473876953,
          "17": -19.56322479248047,
          "18": -16.531192779541016,
          "19": 0.17441190779209137,
          "20": -34.96226501464844,
          "21": -3.2515265941619873,
          "22": 4.626910209655762,
          "23": -3.541239023208618,
        },
      },
      "5": {
        bias: -0.15658092498779297,
        weights: {
          "0": -0.11053843051195145,
          "1": 0.04162662476301193,
          "2": -0.1378776729106903,
          "3": -0.1822817623615265,
          "4": 0.030051328241825104,
          "5": -0.162489116191864,
          "6": 0.09938161820173264,
          "7": -0.04871324077248573,
          "8": 0.026226123794913292,
          "9": -0.02304242178797722,
          "10": 0.11090743541717529,
          "11": -0.13009832799434662,
          "12": 0.048562679439783096,
          "13": 0.13435636460781097,
          "14": -0.16821549832820892,
          "15": 0.18887463212013245,
          "16": -0.03681705892086029,
          "17": -0.0022220821119844913,
          "18": 0.00923183374106884,
          "19": 0.02552207000553608,
          "20": -0.08996159583330154,
          "21": 0.04997674375772476,
          "22": -0.00967515166848898,
          "23": -0.01477250549942255,
        },
      },
      "6": {
        bias: 23.63849449157715,
        weights: {
          "0": -3.431553840637207,
          "1": -2.0652055740356445,
          "2": 17.727853775024414,
          "3": -1.1001991033554077,
          "4": -8.428446769714355,
          "5": 30.516345977783203,
          "6": 31.140640258789062,
          "7": -5.21994161605835,
          "8": -7.2573089599609375,
          "9": 0.24242380261421204,
          "10": 15.222529411315918,
          "11": -7.580299377441406,
          "12": 0.467937707901001,
          "13": 0.15224123001098633,
          "14": -2.276017665863037,
          "15": 0.11739464104175568,
          "16": 2.8736660480499268,
          "17": 7.952842712402344,
          "18": -0.7742744088172913,
          "19": 0.1558278501033783,
          "20": 17.557842254638672,
          "21": -1.0052297115325928,
          "22": -1.292239785194397,
          "23": 3.289055824279785,
        },
      },
      "7": {
        bias: -0.1902274489402771,
        weights: {
          "0": -0.20727135241031647,
          "1": 0.04907725751399994,
          "2": -0.20073561370372772,
          "3": 0.050505705177783966,
          "4": -0.1359080821275711,
          "5": 0.10787045955657959,
          "6": -0.04743864759802818,
          "7": -0.0874892994761467,
          "8": -0.20872251689434052,
          "9": -0.08851751685142517,
          "10": -0.007073380518704653,
          "11": -0.11689764261245728,
          "12": -0.21145294606685638,
          "13": -0.05200605094432831,
          "14": 0.09306010603904724,
          "15": 0.07942711561918259,
          "16": 0.09227829426527023,
          "17": 0.10205847024917603,
          "18": -0.13972057402133942,
          "19": -0.056052930653095245,
          "20": 0.07553730905056,
          "21": 0.06163186952471733,
          "22": 0.09740936011075974,
          "23": -0.22268661856651306,
        },
      },
      "8": {
        bias: -9.085457801818848,
        weights: {
          "0": -18.06673812866211,
          "1": 119.50321197509766,
          "2": 1.7326339483261108,
          "3": 12.156244277954102,
          "4": 18.631450653076172,
          "5": -0.27058959007263184,
          "6": -6.893415927886963,
          "7": -39.7545051574707,
          "8": 79.87184143066406,
          "9": 47.026649475097656,
          "10": -32.35298538208008,
          "11": -35.1061897277832,
          "12": -37.59819793701172,
          "13": -0.18385319411754608,
          "14": 109.37455749511719,
          "15": 0.04074495658278465,
          "16": 6.58126974105835,
          "17": -2.801272392272949,
          "18": -58.23817443847656,
          "19": 0.1639329195022583,
          "20": -27.306411743164062,
          "21": 48.9422607421875,
          "22": 5.252211093902588,
          "23": 15.518438339233398,
        },
      },
      "9": {
        bias: 58.79301071166992,
        weights: {
          "0": -5.842248439788818,
          "1": -5.522356986999512,
          "2": 44.542842864990234,
          "3": -1.995154619216919,
          "4": -15.98209285736084,
          "5": 69.00623321533203,
          "6": 74.83494567871094,
          "7": -16.073726654052734,
          "8": -21.587112426757812,
          "9": 3.185760498046875,
          "10": 36.82870864868164,
          "11": -19.33803367614746,
          "12": 1.3707044124603271,
          "13": 0.19872811436653137,
          "14": -5.543245315551758,
          "15": -0.17154847085475922,
          "16": 3.6088943481445312,
          "17": 19.823665618896484,
          "18": 3.251039981842041,
          "19": -0.019026122987270355,
          "20": 42.60488510131836,
          "21": -3.288378953933716,
          "22": -2.518136501312256,
          "23": 9.232664108276367,
        },
      },
      "10": {
        bias: -0.23629628121852875,
        weights: {
          "0": 0.15101779997348785,
          "1": -0.08856072276830673,
          "2": -0.06178199127316475,
          "3": 0.019786542281508446,
          "4": -0.004369866102933884,
          "5": 0.02935062348842621,
          "6": -0.006329414434731007,
          "7": -0.14637118577957153,
          "8": 0.16341909766197205,
          "9": -0.1978355497121811,
          "10": -0.2057465761899948,
          "11": -0.17293480038642883,
          "12": -0.004124095197767019,
          "13": 0.03475532680749893,
          "14": -0.044204242527484894,
          "15": -0.012945585884153843,
          "16": -0.16161546111106873,
          "17": 0.11430135369300842,
          "18": 0.0773954689502716,
          "19": 0.1188356801867485,
          "20": -0.08813890069723129,
          "21": 0.08866281062364578,
          "22": 0.09615549445152283,
          "23": -0.0802575945854187,
        },
      },
      "11": {
        bias: -5.931922912597656,
        weights: {
          "0": -25.592361450195312,
          "1": 93.5892105102539,
          "2": 32.27545928955078,
          "3": -32.77754592895508,
          "4": 25.68341064453125,
          "5": -7.638684272766113,
          "6": -14.417251586914062,
          "7": -33.04159164428711,
          "8": 60.5063591003418,
          "9": -19.63787269592285,
          "10": -20.31297492980957,
          "11": 29.2036190032959,
          "12": 14.695664405822754,
          "13": -0.10586676746606827,
          "14": 78.71294403076172,
          "15": 0.0660778284072876,
          "16": -47.418888092041016,
          "17": -8.394570350646973,
          "18": -29.119985580444336,
          "19": 0.13484996557235718,
          "20": -15.028572082519531,
          "21": 60.638938903808594,
          "22": 7.683727741241455,
          "23": 9.985712051391602,
        },
      },
    },
    {
      "0": {
        bias: 3.785482168197632,
        weights: {
          "0": -2.6169941425323486,
          "1": 17.60530662536621,
          "2": -3.8318214416503906,
          "3": 10.691374778747559,
          "4": 1.3418269157409668,
          "5": -0.11083599179983139,
          "6": -0.7734163403511047,
          "7": -0.14453299343585968,
          "8": -4.062811851501465,
          "9": -1.72816002368927,
          "10": -0.10798469930887222,
          "11": -3.9755218029022217,
        },
      },
      "1": {
        bias: 8.487993240356445,
        weights: {
          "0": -6.00602912902832,
          "1": -7.9485249519348145,
          "2": -4.519221782684326,
          "3": -6.820836544036865,
          "4": -6.871004581451416,
          "5": 0.03734388202428818,
          "6": -0.5460842847824097,
          "7": 0.1820646971464157,
          "8": 16.740583419799805,
          "9": -1.3783971071243286,
          "10": -0.09931732714176178,
          "11": 13.284420013427734,
        },
      },
      "2": {
        bias: 1.9053599834442139,
        weights: {
          "0": -1.1781779527664185,
          "1": -4.252586841583252,
          "2": -0.6695464849472046,
          "3": -1.091383934020996,
          "4": 4.455814838409424,
          "5": 0.06006704643368721,
          "6": -0.10647343844175339,
          "7": -0.19881367683410645,
          "8": 1.0410053730010986,
          "9": -0.2944127917289734,
          "10": -0.013132774271070957,
          "11": -3.246673822402954,
        },
      },
      "3": {
        bias: 3.912886142730713,
        weights: {
          "0": 21.587371826171875,
          "1": -9.805130004882812,
          "2": -5.419160842895508,
          "3": -7.39932918548584,
          "4": 0.6346815824508667,
          "5": 0.014233294874429703,
          "6": -1.2012072801589966,
          "7": -0.11068335920572281,
          "8": -10.345047950744629,
          "9": -3.033729076385498,
          "10": -0.08868534862995148,
          "11": 3.1733360290527344,
        },
      },
      "4": {
        bias: 6.612552642822266,
        weights: {
          "0": -7.7228899002075195,
          "1": -13.158429145812988,
          "2": -4.297220706939697,
          "3": -5.720444679260254,
          "4": 15.432483673095703,
          "5": 0.09653187543153763,
          "6": 0.7353907823562622,
          "7": 0.03552106022834778,
          "8": -1.9612312316894531,
          "9": 1.1762990951538086,
          "10": 0.05001826956868172,
          "11": -7.7846527099609375,
        },
      },
      "5": {
        bias: 11.069141387939453,
        weights: {
          "0": -9.07518482208252,
          "1": -2.814206600189209,
          "2": 22.12615203857422,
          "3": -2.9885435104370117,
          "4": -5.389570713043213,
          "5": 0.08876613527536392,
          "6": -0.7795677781105042,
          "7": -0.16072340309619904,
          "8": -8.056530952453613,
          "9": -1.2348450422286987,
          "10": -0.16245359182357788,
          "11": -2.9394032955169678,
        },
      },
      "6": {
        bias: 26.984577178955078,
        weights: {
          "0": -1.1030473709106445,
          "1": -1.7948237657546997,
          "2": -7.6328229904174805,
          "3": 0.17522485554218292,
          "4": -14.248124122619629,
          "5": 0.018873590975999832,
          "6": 5.798141956329346,
          "7": -0.10526528209447861,
          "8": -2.4612033367156982,
          "9": 14.031733512878418,
          "10": -0.10980001091957092,
          "11": -6.4822258949279785,
        },
      },
    },
  ],
  outputLookup: true,
  inputLookup: true,
  activation: "leaky-relu",
  trainOpts: {
    iterations: 20000,
    errorThresh: 0.005,
    log: false,
    logPeriod: 10,
    learningRate: 0.3,
    momentum: 0.1,
    callbackPeriod: 10,
    beta1: 0.9,
    beta2: 0.999,
    epsilon: 1e-8,
  },
};

export default zooNNmodel;
